var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoveArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "move-arrows",
    clipPath: "url(#clip0_1066_39099)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M17.7475 8.65849L19.2526 7.34148L23.3288 12L19.2526 16.6585L17.7475 15.3415L19.9905 12.778L12.973 12.9729L12.7781 19.9904L15.3415 17.7474L16.6585 19.2525L12 23.3287L7.34151 19.2525L8.65852 17.7474L11.222 19.9904L11.027 12.973L4.00964 12.7781L6.25261 15.3415L4.74746 16.6585L0.671265 12L4.74746 7.34149L6.25261 8.6585L4.00954 11.222L11.0271 11.0271L11.222 4.00947L8.65853 6.2525L7.34152 4.74734L12 0.67115L16.6585 4.74734L15.3415 6.2525L12.7781 4.00948L12.973 11.027L19.9904 11.2219L17.7475 8.65849Z",
    fill: "#241C15"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1066_39099"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveArrows);
export default __webpack_public_path__ + "static/media/move-arrows.2f4a794f9ffc3d81658f117c13628d70.svg";
export { ForwardRef as ReactComponent };